(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('UserDeleteController', UserDeleteController);

    UserDeleteController.$inject = ['$scope', '$uibModalInstance', 'UserService', 'userData'];

    function UserDeleteController($scope, $uibModalInstance, UserService, userData) {
        var vm = this;
        vm.requestRunning = false;

        vm.userData = {email: userData.email};

        vm.close = function () {
            if (!vm.requestRunning) {
                $scope.$emit('userEditCancel');
                $uibModalInstance.dismiss('cancel');
            }
        }

        vm.delete = function () {
            vm.requestRunning = true;
            UserService.deleteUser(userData.id).then(successDelete).catch(errorDelete);
        }

        function successDelete(data) {
            vm.requestRunning = false;
            $scope.$emit('userDeleteSuccess', data);
        }

        function errorDelete(response) {
            vm.requestRunning = false;
            UserService.errorModalConstructor(response, 'delete');
        }

    }
})();

